define(['edge/platform/base/BaseCtrl'], (BaseCtrl)=> {
    const fn = ($scope, StateUtils, submissionViewModel)=> {
        const ctrl = Object.create(BaseCtrl);
        const submissionVM = submissionViewModel();
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        
        ctrl.init = ()=> {
            $scope.questionSets = submissionVM.draftData.lobs.homeowners.preQualQuestionSets.value;

        for (var key in $scope.questionSets[0]["answers"]){
           //yearOfCons_aaa
           if(key == "yearOfCons_aaa")
           {
                $scope.questionSets[0]["answers"][key] = "1900";
           }else if(key == "DWOccupied_aaa"){
                $scope.questionSets[0]["answers"][key] = "owner_prim";  
           }else{
                $scope.questionSets[0]["answers"][key] = "false";
           }
        }
        

        
       flowModel.next(submissionVM,true);

        };

        ctrl.next = (flowNextFn, form)=> {

            //prequal question requiredness not captured in the submission model, so pass form validity for isValid check
            flowNextFn(submissionVM, form.valid);
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/controllers/HOPrequalQuestionsCtrl.js
 **/